import { GET_ALL_RESOURCES_TYPES } from "./types";

const ResourceTypeReducer = (state, action) => {
    const { type, payload } = action;
    switch (type) {
        case GET_ALL_RESOURCES_TYPES:
            return {
                ...state,
                resourcesTypes: payload,
                isFetching: false,
                wasFetched: true
            }
        default:
            return state
    }
}
export default ResourceTypeReducer